import type {
	IActionsForRoleStates,
	IActionStates,
	IRoleByActionStates,
	IRolesForActionStates,
} from '../../../interface/state/IActionState';
import { actionType } from '../../types';
import { createAPI, deleteAPI, getAPI, getByIdAPI, getFetchAPI, updateAPI } from '../api-utils';

export const create = createAPI<undefined, { name: string }>({
	actionType: actionType.create,
	url: '/api/v1/Action',
});

export const get = getAPI<IActionStates>({
	actionType: actionType.get,
	url: '/api/v1/Action',
	type: 'core',
});

export const getByID = getByIdAPI({
	actionType: actionType.getByID,
	url: '/api/v1/Action',
});

export const update = updateAPI<undefined, { id: number; name: string }>({
	actionType: actionType.update,
	url: '/api/v1/Action',
});

export const deleteByActionIds = deleteAPI<undefined, { actionIds: number[] }>({
	actionType: actionType.deleteByActionIds,
	url: '/api/v1/Action',
});

export const unassignMultipleForRoles = getFetchAPI<undefined, { roleId: number; actionIds: number[] }>({
	actionType: actionType.unassignMultipleForRoles,
	url: '/api/v1/Action/UnassignMultipleActionsForRole',
});

export const assignMultipleRoles = getFetchAPI<undefined, { roleIds: number[]; actionId: number }>({
	actionType: actionType.assignMultipleRoles,
	url: '/api/v1/Action/assign-multiple-roles',
});

export const unassignMultipleRoles = getFetchAPI<undefined, { roleIds: number[]; actionId: number }>({
	actionType: actionType.unassignMultipleRoles,
	url: '/api/v1/Action/unassign-multiple-roles',
});

export const getForRole = getAPI<IActionsForRoleStates>({
	actionType: actionType.getForRole,
	url: '/api/v1/Action/getActionsForRole',
	type: 'core',
});

export const getRoleByID = getByIdAPI<IRoleByActionStates>({
	actionType: actionType.getRoleByID,
	url: '/api/v1/Action/getActionsForRole',
});

export const getForMultipleRoles = getFetchAPI<IActionsForRoleStates, { roles: string[] }>({
	actionType: actionType.getForMultipleRoles,
	url: '/api/v1/Action/getActionsForMultipleRoles',
});

// B2.10: /api/v1/ActionRole endpoints were deleted server-side (consolidated into
// RoleController's bulk assign/unassign + ActionController.GetRolesForAction). The
// previous Redux actions (createRole, getRole, deleteRole) had no UI callers so
// they were removed alongside the backend deletion.

export const getRoles = getByIdAPI<IRolesForActionStates>({
	actionType: actionType.getRoles,
	url: '/api/v1/Action/getRolesForAction',
});
